import { useQuery } from "@tanstack/react-query";
import { Fragment, useMemo } from "react";
import { Container } from "react-bootstrap";
import { Outlet, useNavigate } from "react-router-dom";
import { useWindowSize } from "react-use";
import Swal from "sweetalert2";
import Laoding from "../../components/Loading";
import { getRequestByAuth } from "../../function/helper";
import Footer from "../../modules/public/footer/footer";
import Menu from "../../modules/public/menu/menu";
import EnterDigikala from "./components/EnterDigikala";
import LargeSidebar from "./components/LargeSidebar";
import SmallSidebar from "./components/SmallSidebar";
import style from "./DigikalaSeller.module.css";
import classNames from "classnames";
import SellerInfo from "./components/SellerInfo";
import AvaexInfo from "./components/AvaexInfo";

export default function DigikalaSeller() {
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const isMobile = useMemo(() => width < 992, [width]);

  const { isFetching, data } = useQuery({
    queryKey: ["DigikalaSeller"],
    queryFn: () =>
      getRequestByAuth("/v2/digikala/getSeller").then(res => {
        if (res && res.status === 200) {
          return res.data;
        }

        Swal.fire({
          icon: "error",
          confirmButtonText: "باشه",
          text: res.message,
        }).then(res => {
          if (res.isDismissed || res.isConfirmed) {
            return navigate("/");
          }
        });

        return null;
      }),
    staleTime: 0,

    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: 0,
    gcTime: 60 * 60 * 1000,
  });

  return (
    <Fragment>
      <Menu />

      <main
        className="d-flex flex-grow-1 position-relative overflow-x-hidden rtl-all px-1 w-100"
        style={{ minHeight: "100vh" }}
      >
        {isMobile && <SmallSidebar />}

        <div className="d-flex my-5 py-4 column-gap-2 rounded-2 px-lg-2 flex-grow-1 mx-auto w-100 px-0 px-md-1 px-xxl-5">
          {!isMobile && <LargeSidebar />}

          <div
            className={classNames(
              "border border-1 rounded p-3 flex-grow-1",
              style.main
            )}
          >
            {isFetching && <Laoding className="h-25" />}
            {!isFetching && data && data.redirect && (
              <EnterDigikala redirectUrl={data.redirectUrl} />
            )}
            {!isFetching && data && !data.redirect && (
              <Fragment>
                <SellerInfo data={data} />
                <AvaexInfo data={data} />
                <Outlet context={data} />
              </Fragment>
            )}
          </div>
        </div>
      </main>

      <Footer marginTop={0} />
    </Fragment>
  );
}
